export default from './Video';



// WEBPACK FOOTER //
// ./src/containers/Video/index.js